module.exports = __webpack_public_path__ + "a15d533ab40e47d3415b85e0433ba82d.fbx";